// extracted by mini-css-extract-plugin
export default {"scope":"lnPq0","scope--color-bad":"yX9DJ","progress":"sAIkX","scope--color-ok":"mOE2f","scope--color-good":"FJ2NW","value":"epYhC","number":"GYKyE"};